export default __webpack_public_path__ + "static/clientWork3-e5b36159ae899367354db3841a342c68.png";